import { render, staticRenderFns } from "./Impressao.vue?vue&type=template&id=68fde98a&scoped=true&"
import script from "./Impressao.vue?vue&type=script&lang=js&"
export * from "./Impressao.vue?vue&type=script&lang=js&"
import style0 from "./Impressao.vue?vue&type=style&index=0&id=68fde98a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fde98a",
  null
  
)

export default component.exports